import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { LedgerAccountsDetailPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { LedgerAccountDetailDataTable } from 'modules/finance/components/LedgerAccountDetail/Datatable'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { ExportSidepanel } from 'modules/universal_exports/components/ExportSidepanel'

const LedgerAccountDetailPage = () => {
  const { ledgerAccountId } = useParams()
  const [showExportSidepanel, setShowExportSidepanel] = useState<boolean>(false)
  const { error, data, loading } = useQuery(LedgerAccountsDetailPageDocument, {
    variables: {
      id: String(ledgerAccountId),
    },
  })

  const ledgerAccount = data?.finance?.accounts[0]
  const canManageJournalEntries = data?.finance?._policies?.journalEntriesManage?.can ?? false

  return (
    <ResponsivePage.Body
      error={error}
      loading={loading}
      authorized={!!ledgerAccount && canManageJournalEntries}
    >
      {ledgerAccount && showExportSidepanel && (
        <ExportSidepanel
          resource="finance.journal_line"
          overrideFilters={{ account_id: [ledgerAccount.id] }}
          onClose={() => setShowExportSidepanel(false)}
        />
      )}
      {ledgerAccount && (
        <LedgerAccountDetailDataTable
          ledgerAccount={ledgerAccount}
          onExportClick={() => setShowExportSidepanel(true)}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default LedgerAccountDetailPage
